// gitlab-evidence-client-base-url-guard.ts
//
// M2 fix (code-reviewer-260909-p7-m3.md): split out of
// gitlab-merge-request-evidence-client.ts to keep that file under the
// 200-line convention. Guards the official `baseUrl` override (deps.baseUrl
// / input.baseUrl) — refuses anything that is neither `https://` nor
// `http://` at a loopback authority, so a mistaken `baseUrl: "http://..."`
// can never downgrade the `PRIVATE-TOKEN` header to plaintext transport.

// Loopback hosts allowed to use plain http:// — local fake servers only
// (tests / dev). `host` here is the AUTHORITY of the baseUrl (may include a
// port, e.g. "127.0.0.1:41231" or "[::1]:41231"), never the GitLab `host`
// input (that one is compared for PAT lookup only).
const LOOPBACK_HOST_PATTERN = /^(127\.0\.0\.1|localhost|\[::1\])(:\d+)?$/i;

/**
 * True when `url` is either `https://` (any host), or `http://` pointed at
 * a loopback authority. False for any other scheme/host combination — most
 * importantly `http://` at a non-loopback host.
 */
export function isSecureOrLoopbackBaseUrl(url: string): boolean {
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return false;
  }
  if (parsed.protocol === "https:") return true;
  if (parsed.protocol === "http:") return LOOPBACK_HOST_PATTERN.test(parsed.host);
  return false;
}
